"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCSVMapper = exports.DefaultKeyMappings = void 0;
var core_api_1 = require("@ikegps/core-api");
var index_1 = require("../../index");
var location_field_1 = require("../fields/location.field");
var nested_list_field_1 = require("../fields/nested.list.field");
var MappingFunctions = (_a = {},
    // [IkeFieldType.NUMBER]: (field: CollectionModelFieldNumber, val: string) => field.Mutator.manual(val),
    _a[core_api_1.IkeFieldType.TEXT] = function (field, val) {
        if (val == null || val === '') {
            return true;
        }
        field.Mutator.manual(String(val));
        return true;
    },
    _a[core_api_1.IkeFieldType.SELECT_LIST] = function (field, valIn) {
        if (valIn == null || valIn === '') {
            return true;
        }
        var val = String(valIn);
        field.Mutator.manual(val);
        var hasValue = field.hasValue();
        if (hasValue) {
            return true;
        }
        // Attempt to match based on the schema options
        var textMatch = field.schema.options.find(function (opt) { return opt.text.toLowerCase() === val.toLowerCase(); });
        if (textMatch) {
            field.Mutator.manual(textMatch.value);
        }
        return field.hasValue();
    },
    _a[core_api_1.IkeFieldType.NESTED_LIST] = function (field, val) {
        if (val == null || val === '') {
            return true;
        }
        field.Mutator.manual(nested_list_field_1.CollectionModelFieldNestedList.parse(val));
        return field.hasValue();
    },
    _a[core_api_1.IkeFieldType.LOCATION] = function (field, val, key) {
        var oldValue = Object.assign({}, field.value);
        var value = parseFloat(val);
        if (isNaN(value) || isNaN(val)) {
            return false;
        }
        switch (key) {
            case 'lat':
                oldValue.latitude = parseFloat(val);
                field.Mutator.manual(oldValue);
                return field.value.latitude === oldValue.latitude;
            case 'lng':
                oldValue.longitude = parseFloat(val);
                field.Mutator.manual(oldValue);
                return field.value.longitude === oldValue.longitude;
            default:
                throw new Error('Invalid location key: "' + key + '\'');
        }
    },
    _a);
/**
 * Lower cased alias's for the keys in the mapping process.
 */
exports.DefaultKeyMappings = {
    lat: ['lat', 'latitude'],
    lng: ['lng', 'longitude', 'long']
};
var IkeCSVMapper = /** @class */ (function () {
    function IkeCSVMapper(csv, form) {
        this.csv = null;
        this.form = null;
        /** List of fields that can be mapped to */
        this.mappings = [];
        /** List of the collections that have been created by these mappings */
        this.processed = [];
        this.csv = csv;
        this.form = form;
        for (var _i = 0, _a = this.form.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            if (field.type === 'location') {
                this.mappings.push({ field: field, fieldKey: 'lat', csvIndex: -1, isValid: true });
                this.mappings.push({ field: field, fieldKey: 'lng', csvIndex: -1, isValid: true });
            }
            else if (MappingFunctions[field.type]) {
                this.mappings.push({ field: field, csvIndex: -1, isValid: true });
            }
        }
    }
    IkeCSVMapper.prototype.toJSON = function () {
        var output = [];
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var mapping = _a[_i];
            if (mapping.csvIndex === -1) {
                continue;
            }
            output.push({
                fieldId: mapping.field.id,
                fieldKey: mapping.fieldKey,
                csvHeader: this.csv.headers[mapping.csvIndex]
            });
        }
        return output;
    };
    IkeCSVMapper.prototype.getMapping = function (fieldId, fieldKey) {
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var mapping = _a[_i];
            if (mapping.field.id !== fieldId) {
                continue;
            }
            if (fieldKey == null || fieldKey === mapping.fieldKey) {
                return mapping;
            }
        }
        return null;
    };
    IkeCSVMapper.prototype.setMapping = function (mapping, csvHeaderIndex, shouldProcess) {
        if (shouldProcess === void 0) { shouldProcess = true; }
        if (csvHeaderIndex == null || isNaN(csvHeaderIndex) || csvHeaderIndex < 0) {
            mapping.csvIndex = -1;
        }
        else {
            mapping.csvIndex = csvHeaderIndex;
        }
        if (shouldProcess) {
            this.processRows();
        }
    };
    IkeCSVMapper.prototype.getCollectionValue = function (mapping, index) {
        var collection = this.processed[index];
        var raw = this.csv.rows[index];
        var rawValue = raw[mapping.csvIndex];
        var field = collection.getField(mapping.field.id);
        if (location_field_1.CollectionModelFieldLocation.isLocationField(field)) {
            var value = 0;
            switch (mapping.fieldKey) {
                case 'lat':
                    value = field.value.latitude;
                    break;
                case 'lng':
                    value = field.value.longitude;
                    break;
                default: throw new Error('Invalid mapping key');
            }
            return { value: String(value), isValid: value !== 0, raw: rawValue };
        }
        var hasRawValue = rawValue != null && rawValue !== '';
        if (hasRawValue) {
            return { value: field.displayValue, isValid: field.hasValue(), raw: rawValue };
        }
        else {
            return { value: field.displayValue, isValid: true, raw: rawValue };
        }
    };
    IkeCSVMapper.prototype.reset = function () {
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var mapping = _a[_i];
            mapping.csvIndex = -1;
            mapping.isValid = true;
        }
    };
    /**
     * Attempt to guess some default mappings based off the headers in the CSV and the fields in the form
     */
    IkeCSVMapper.prototype.setDefaultMappings = function () {
        var _this = this;
        var headerSearch = {};
        for (var i = 0; i < this.csv.headers.length; i++) {
            var header = this.csv.headers[i];
            headerSearch[header.toLowerCase()] = i;
        }
        var hasMapped = false;
        var applyMapping = function (key, mapping) {
            if (mapping.csvIndex > -1) {
                return true;
            }
            var index = headerSearch[key];
            if (index != null) {
                delete headerSearch[key];
                _this.setMapping(mapping, index, false);
                hasMapped = true;
                return true;
            }
            return false;
        };
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var mapping = _a[_i];
            var field = mapping.field, fieldKey = mapping.fieldKey;
            // Is there a direct match between header name and field name
            if (applyMapping(field.displayName.toLowerCase(), mapping)) {
                continue;
            }
            // See if any other keys will map
            var searchKeys = exports.DefaultKeyMappings[fieldKey];
            if (searchKeys == null) {
                continue;
            }
            for (var _b = 0, searchKeys_1 = searchKeys; _b < searchKeys_1.length; _b++) {
                var search = searchKeys_1[_b];
                if (applyMapping(search, mapping)) {
                    break;
                }
            }
        }
        if (hasMapped) {
            this.processRows();
        }
    };
    Object.defineProperty(IkeCSVMapper.prototype, "isValid", {
        get: function () {
            if (this.csv.rows.length === 0) {
                return false;
            }
            var hasMappings = false;
            for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
                var field = _a[_i];
                if (field.csvIndex > -1) {
                    hasMappings = true;
                }
                if (field.isValid === false) {
                    return false;
                }
            }
            return hasMappings;
        },
        enumerable: false,
        configurable: true
    });
    IkeCSVMapper.prototype.processRows = function () {
        this.processed = [];
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var field = _a[_i];
            field.isValid = true;
        }
        for (var _b = 0, _c = this.csv.rows; _b < _c.length; _b++) {
            var row = _c[_b];
            this.processed.push(this.processRow(row));
        }
    };
    IkeCSVMapper.prototype.processRow = function (row) {
        var collection = index_1.IkeModel.Collection.create(this.form, null); // TODO do we always need a loader?
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var mapping = _a[_i];
            if (mapping.csvIndex === -1) {
                continue;
            }
            var field = collection.getField(mapping.field.id);
            var Mapper = MappingFunctions[mapping.field.type];
            var isValid = Mapper(field, row[mapping.csvIndex], mapping.fieldKey);
            if (isValid === false) {
                mapping.isValid = false;
            }
        }
        return collection;
    };
    return IkeCSVMapper;
}());
exports.IkeCSVMapper = IkeCSVMapper;
//# sourceMappingURL=csv.mapper.js.map